import { NewsStory } from "../types/NewsTypes";
import { languageEnglish, languageDutch } from "../i18n";

export const getStoryNameInLocale = (
  story: NewsStory,
  locale: string | undefined,
  isAutoTranslated?: boolean
) => {
  if (isAutoTranslated) {
    return story.name;
  }

  if (locale === languageEnglish) {
    const translatedData = story.translated_slugs.find(
      (obj) => obj.lang === languageEnglish
    );

    if (translatedData?.name) {
      return translatedData?.name;
    }
  }

  return story.name;
};

export const getSlugInLocale = (
  story: NewsStory,
  locale: string | undefined
) => {
  return locale === languageDutch
    ? `/${story.default_full_slug}`
    : `/${locale}/${
        story.translated_slugs.find((obj) => obj.lang === locale)?.path ||
        story.default_full_slug
      }`;
};
